import { useRef } from 'react';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const SideDrawer = ({ open, setOpen, children }) => {
	const WIDTH_DRAWER_CLOSED = 60;
	const WIDTH_ICON = 40;
	let refDrawer = useRef(null);

	return (
		<>
			{!open && (
				<Typography
					sx={{
						transform: 'rotate(90deg) translate(0, -100%)',
						position: 'fixed',
						top: '50%',
						right: '0',
					}}
					color='primary'
					variant='h6'
					noWrap
				>
					Job Category Directory
				</Typography>
			)}
			<Drawer
				ref={refDrawer}
				PaperProps={{
					sx: {
						width: open ? '20%' : `${WIDTH_DRAWER_CLOSED}px`,
						overflowX: 'hidden',
						paddingTop: '64px',
					},
					elevation: 10,
					onClick: () => {
						if (!open) {
							setOpen(true);
						}
					},
				}}
				anchor='right'
				open={open}
				variant='permanent'
			>
				<Box
					sx={{
						position: 'absolute',
						top: '50%',
						marginLeft: `${
							(WIDTH_DRAWER_CLOSED - WIDTH_ICON) / 2
						}px`,
						marginRight: `${
							(WIDTH_DRAWER_CLOSED - WIDTH_ICON) / 2
						}px`,
					}}
				>
					<IconButton onClick={() => setOpen(isOpen => !isOpen)}>
						{open ? <ChevronRightIcon /> : <ChevronLeftIcon />}
					</IconButton>
				</Box>
				<Box
					sx={{
						padding: `16px 16px 16px ${WIDTH_DRAWER_CLOSED}px`,
					}}
				>
					{open && children}
				</Box>
			</Drawer>
		</>
	);
};

export { SideDrawer };
